export default __webpack_public_path__ + "static/media/query-management.2b90a5ad.svg";